import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable()
export class TauxTvaService
{
    constructor(public apiService: ApiService) { }

    onTauxNormalTva() {
        this.apiService.get('facturation-global-value')
            .subscribe(retour => {
                if (retour.status === 200) {
                    localStorage.setItem('plafondAgrementHt',retour.data.fgv_plafond_agrement_ht)
                    localStorage.setItem('tauxNormalTva',retour.data.fgv_taux_tva_normal)
                    localStorage.setItem('tauxReduitTva',retour.data.fgv_taux_tva_reduit)
                }
        });
    }
}
